import { Typography } from '@kohler-dsm-library/kohler-core';
import { LocationIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './LocationPickButton.module.css.mjs';

const LocationPickButton = (props) => {
  const { text, className, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Typography, { component: "button", type: "button", size: "overline", className: clsx(classes.locationPickButtonContainer, className), ...rest }, /* @__PURE__ */ React.createElement(LocationIcon, { withBoundingBox: false }), " ", text);
};

export { LocationPickButton };
